<template>
  <div ref="imgsRef" class="imgs">
    <img
      v-for="(x, i) in list.filter((x) => x)"
      :key="i"
      :src="x"
      loading="lazy"
    />
    <div
      class="pointer"
      :style="{ left: `${left}px` }"
      @mousedown="onMouseDown"
    ></div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ list: any[] }>()

const emit = defineEmits(['change'])

const imgsRef = ref<HTMLElement>()
const left = ref(0)
const imgsWidth = computed(() => imgsRef.value?.clientWidth || 832)

let startX = 0
let oldX = 0

const onMouseDown = (e: MouseEvent) => {
  startX = e.clientX
  oldX = left.value
  document.body.style.cursor = 'col-resize'
}
const onMouseMove = (e: MouseEvent) => {
  e.preventDefault()
  if (!startX) {
    return
  }

  let l = oldX + (e.clientX - startX)
  if (l < 0) {
    l = 0
  }

  if (l > imgsWidth.value) {
    l = imgsWidth.value
  }

  left.value = l
}
const onMouseUp = (e: MouseEvent) => {
  startX = 0
  document.body.style.cursor = ''
  if (imgsRef.value?.contains(e.target as Node)) {
    const { target, offsetX } = e
    left.value = (target as HTMLElement)?.offsetLeft + offsetX
  }
}

watch(left, () => {
  emit('change', left.value / imgsWidth.value)
})

onMounted(() => {
  document.addEventListener('mousemove', onMouseMove)
  document.addEventListener('mouseup', onMouseUp)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousemove', onMouseMove)
  document.removeEventListener('mouseup', onMouseUp)
})
</script>

<style lang="scss" scoped>
.pointer {
  @apply absolute top-0 left-[0] w-[3px] h-full bg-warning-6 z-[1] rounded-[1px];
  cursor: col-resize;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
}
.imgs {
  @apply w-full h-[44px] relative mt-[20px] bg-back-4 flex p-[2px];
  img {
    @apply h-full w-[7.1428%];
    transition: all 0.3s ease;
    &:hover {
      transform: scale(1.1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
